module.exports = __webpack_public_path__ + "images/feature/file-dir-4-dae5229f84b0d0efc14a6e6b9f07746f.png";